import { useEffect } from 'react'

/**
 * Custom hook to invoke a callback on element impression.
 *
 * @param elementRef - reference to the HTML element
 * @param callback - function to invoke on element impression
 */
export default function useImpressionCallback(elementRef: React.RefObject<HTMLElement>, callback?: VoidFunction) {
    useEffect(() => {
        if (!callback) {
            return;
        }
        const intersectionObserver = new IntersectionObserver((entries, observer) => {
            if (entries.filter((entry) => entry.isIntersecting).length > 0) {
                callback?.();
                observer.disconnect();
            }
        }, {
            threshold: 0,
        });
        if (elementRef.current) {
            intersectionObserver.observe(elementRef.current);
        }
        return () => intersectionObserver?.disconnect();
    }, [elementRef, callback]);
}
